import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export type CertificateFormat =
  | "certificate"
  | "certificate-extended"
  | "calculations"
  | "report-residential"
  | "report-commercial"
  | "report-mixed-use";

export interface Certificate {
  id: string;
  format: string;
  notes: string | null;
  generatedAt: string;
  generatedBy: string | null;
  url: string | null;
}

export function useCertificates(recordId: string | undefined) {
  return useQuery({
    queryKey: ["insurance", recordId, "certificates"],
    queryFn: () => api.get<{ certificates: Certificate[] }>(`/api/insurance/${recordId}/certificates`),
    enabled: !!recordId,
  });
}

export interface EmailCertificateInput {
  to: string[];
  cc?: string[];
  subject: string;
  message: string;
  format: CertificateFormat;
}

export function warmCertificatePreview(recordId: number | string, format: CertificateFormat): void {
  api.post(`/api/insurance/${recordId}/pdf/preview-warm`, { format }).catch(() => {});
}

export function useEmailCertificate(recordId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: EmailCertificateInput) =>
      api.post<{ ok: true }>(`/api/insurance/${recordId}/email-certificate`, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["insurance", recordId, "certificates"] });
    },
  });
}
